/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
/* eslint-disable react/no-unknown-property */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import { connect } from 'react-redux';

import { PREVIOUS_CATEGORY_URL_COOKIE } from 'Route/CategoryPage/CategoryPage.config';
import { Breadcrumb as SourceBreadcrumb } from 'SourceComponent/Breadcrumb/Breadcrumb.component';
import { updateUrlRewrite } from 'Store/UrlRewrites/UrlRewrites.action';
import BrowserDatabase from 'Util/BrowserDatabase';
import history from 'Util/History';

import 'SourceComponent/Breadcrumb/Breadcrumb.style';
import './Breadcrumb.extended.style';

/** @namespace Scandipwa/Component/Breadcrumb/Component/mapStateToProps */
export const mapStateToProps = () => ({});

/** @namespace Scandipwa/Component/Breadcrumb/Component/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    updateUrlRewrite: (urlRewrite, requestedUrl) => dispatch(updateUrlRewrite(urlRewrite, requestedUrl))
});

/** @namespace Scandipwa/Component/Breadcrumb/Component */
export class BreadcrumbComponent extends SourceBreadcrumb {
    onBreadcrumbClick(e, url, category_id) {
        e.preventDefault();

        const previousCategoryUrl = BrowserDatabase.getItem(PREVIOUS_CATEGORY_URL_COOKIE);

        if (url === previousCategoryUrl) {
            history.goBack();
        }

        if (category_id) {
            const { updateUrlRewrite } = this.props;

            updateUrlRewrite({
                id: parseInt(category_id, 10),
                type: 'CATEGORY',
                blockBERequest: true // Do not send request to BE for urlRewrite retreival
            }, url);
        }

        history.push(url);
    }

    renderLink() {
        const {
            url,
            index,
            isDisabled,
            category_id
        } = this.props;

        const sanitizedUrl = typeof url === 'object' ? url.pathname : url;

        return (
            <button
              block="Breadcrumb"
              elem="Link"
              // eslint-disable-next-line react/jsx-no-bind
              onClick={ (e) => this.onBreadcrumbClick(e, url, category_id) }
              tabIndex={ isDisabled ? '-1' : '0' }
            >
                <meta itemProp="item" content={ window.location.origin + (sanitizedUrl || '') } />
                <span itemProp="name">
                    { this.renderName() }
                </span>
                <meta itemProp="position" content={ index } />
            </button>
        );
    }

    renderName() {
        const { name } = this.props;

        if (!name) {
            return null;
        }

        return name;
    }

    render() {
        const { index, url, isDisabled } = this.props;

        const isLoading = !url;

        if (isLoading && isDisabled) {
            return null;
        }

        return (
            <li
              block="Breadcrumb"
              mods={ { isLoading } }
              key={ index }
              itemProp="itemListElement"
              itemScope
              itemType="http://schema.org/ListItem"
            >
                { this.renderLink() }
            </li>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BreadcrumbComponent);
